export default "__VITE_ASSET__CfGVHS7t__"